import { api } from "./api";

const ledgerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllLedger: builder.query({
      query: () => "ledger",
      providesTags: ["ledger"],
    }),
    addledger: builder.mutation({
      query: (newCategory) => ({
        url: "ledger",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["ledger"],
    }),
    removeledger: builder.mutation({
      query: (id) => ({
        url: `ledger/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ledger"],
    }),
    editledger: builder.mutation({
      query: (editData) => ({
        url: `ledger`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["ledger"],
    }),
  }),
});

export const {
  useGetAllLedgerQuery,
  useAddledgerMutation,
  useRemoveledgerMutation,
  useEditledgerMutation,
} = ledgerApi;